
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 165.001 165.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M129.7 59v-7.6c0-2.9-1-5.3-3-7.3s-4.5-3-7.3-3h-10.2V30c0-.7-.2-1.3-.7-1.8-.5-.5-1.1-.7-1.8-.7h-8.5c-.7 0-1.3.2-1.8.7-.5.5-.7 1.1-.7 1.8v11.1H68.4V30c0-.7-.2-1.3-.7-1.8-.5-.5-1.1-.7-1.8-.7h-8.5c-.7 0-1.3.2-1.8.7-.5.5-.7 1.1-.7 1.8v11H44.7c-2.9 0-5.3 1-7.3 3s-3 4.5-3 7.3V59c0 .7.2 1.3.7 1.8.5.5 1.1.7 1.8.7h90.4c.7 0 1.3-.2 1.8-.7.5-.5.7-1.1.7-1.8h-.1zM35 69.1c-.5.5-.7 1.1-.7 1.8v55.5c0 2.8 1 5.3 3 7.3s4.4 3 7.3 3h75.1c2.8 0 5.3-1 7.3-3s3-4.4 3-7.3V70.9c0-.7-.2-1.3-.7-1.8-.5-.5-1.1-.7-1.8-.7H36.8c-.7 0-1.3.2-1.8.7z"}})])
          )
        }
      }
    